import { CustomPage, CustomPagesState, PublicSiteCustomRoutes } from './types.mod'
import {
  Option,
  mkWidget,
  Action,
  route,
  none,
  mk_pair,
  some,
  loadingAsyncState,
  unloadedAsyncState,
  async,
  nothing,
  link,
  Fun
} from 'widgets-for-react'
import React = require('react')
import { CustomRouteParams } from '../../cms/router/type.gen'
import { PublicSiteState, defaultLanguage } from '../../../public_site.main.mod'
import { PublicSite_CustomPageData, getPage, getDrupalLanguage } from '../application.mod'
import { Block } from '../../drupal/types_and_parser/standard_blocks.gen'
import { CustomBlock } from '../../drupal/types_and_parser/custom_blocks.mod'
import { TemplateState } from '../../cms/page/types.gen'
import { PageTemplateComponent } from '../../cms/page/widget.gen'
import { CustomBlockData } from '../blocks/custom_blocks/types.mod'
import { ExtraImages, get_default_data_src, get_default_data_srcset } from '../utils/extra_images.mod'
import { GetDrupalBlockImagesLoaders, parseImageUrl } from '../../drupal/rendering/image_utils.mod'
import { DrupalBlock_To_WidgetBlock, parseMediaUrl } from '../../drupal/drupal_to_cms.mod'
import { page } from '../templates/drupal_page.mod'
import { loader } from '../templates/loader.mod'
import { notfound_page } from '../templates/error_page.mod'
import { List } from 'immutable'
import { t } from 'i18next'
import * as i18next from 'i18next'
import { GetOverview, Search } from '../../drupal/api/api.mod'
import { Breadcrumb, PaginatedItem, PageTeaser, SearchResultItem } from '../../drupal/types_and_parser/extra_types.mod'
import { Link } from 'react-router-dom'
import { linkGridBlockClasses } from '../blocks/style.mod'
import { getClassName } from '../../cms/blocks/utils.gen'
import { Pagination } from '../templates/pagination.mod'
import { LinkGridBlockStyle } from '../../cms/blocks/widgets/linkGridBlock.gen'
import { InView } from 'react-intersection-observer'
import { blockInviewHandler } from '../../drupal/rendering/inview_utils.mod'

export const search_overview: CustomPage<CustomPagesState['search_overview']> = {
  widget: (r) =>
    mkWidget({
      run: (setState: (_: Action<CustomPagesState['search_overview']>) => void) => {
        const pageName = r.fst.kind == 'search_overview' ? r.fst.slug : ''
        let ss = r.snd
        const query: string = r.fst.kind == 'search_overview' ? r.fst.query : ''
        const lang: string = r.fst.kind == 'search_overview' ? r.fst.lang : ''

        const setPage = (page: number) => {
          window.history.pushState({}, '', `/${lang}/${pageName}/${r.snd.current_query}/${page}`)
          setState((s) => ({
            ...s,
            overview_page: page,
            get_searches: Search(r.snd.current_query, "", page, 10,lang)
          }))
        }

        const setQuery = (query: string) => {
          setState((s) => ({
            ...s,
            current_query: query,
          }))
        }

        const runQuery = () => {
          window.history.pushState({}, '', `/${lang}/${pageName}/${query}/${0}`) 
        }

        const searchResult =
          ss.get_searches.kind == 'loaded'
            ? ss.get_searches.value
            : ss.get_searches.kind == 'failed'
            ? ({} as PaginatedItem<SearchResultItem>)
            : null

        r.snd = ss

        const props = {
          StandardBlockImagesLoader: GetDrupalBlockImagesLoaders,
          StandardBlock_To_Widget: DrupalBlock_To_WidgetBlock,
          errorPage: notfound_page,
          loadingPage: loader
        }

        return (
          <main id="a11y-main" className="main main--search-results">
            <InView
              as="header"
              onChange={(inView) => blockInviewHandler('pageHeader', inView, 'io-page-header', 'inview')}
              triggerOnce={true}
              threshold={0}
              id="io-page-header"
              className="pageheader pageheader--flat no-image"
            >
              <div className="pageheader__inner">
                <div className="pageheader__content container container--m">
                  <div className="pagegeader__message">
                    <div className="pageheader__header">
                      <h1 className="pageheader__title">{t("search:search")}</h1>
                    </div>
                  </div>                    
                </div>
              </div>
            </InView>
            <div className="search-results">
            {async<PaginatedItem<SearchResultItem>>(null, {
              connectionError: mkWidget({
                run: (_) => {
                  return <div>Connection error.</div>
                }
              }),
              otherError: mkWidget({
                run: (_) => {
                  return <section className="search-results__section container container--m grid--gutter"><h1 className="search-results__title title--m">Error</h1></section>
                }
              }),
              loading: (_) =>
                mkWidget({
                  run: (_) => {
                    return  <></>
                  }
                })
            })(ss.get_searches).run((res) =>
              setState((s) => {
                let s1 = res(s.get_searches)
                if (s1.kind == "loaded") {
                  if (s1.value.items.count() > 0) {
                    window.dataLayer.push({
                      event: 'event.refresco',
                      category: 'Search',
                      action: 'Result',
                      label: s.current_query,
                    })
                  } else {
                    window.dataLayer.push({
                      event: 'event.refresco',
                      category: 'Search',
                      action: 'No result',
                      label: s.current_query,
                    })
                  }
                }

                return { ...s, get_searches: s1 }
              })
            )}
            {ss.get_searches.kind != 'loading'
            ? searchOverview(
                searchResult,
                setPage,
                setQuery,
                runQuery,
                ss.overview_page,
                ss.current_query,
                lang
              )
            : <section className="search-results__section container container--m grid--block">
                <div className="loader">
                  <div className="loader__inner"></div>
                </div>
              </section>}
            </div>
          </main>
        )
      }
    }),
    route: route<
      { slug: string; page: string; lang: string, query: string },
      CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>
    >('/:lang?/:slug(search)/:query/:page(\\d+)?', (s) => ({
      kind: 'search_overview',
      slug: s.slug,
      query: s.query,
      page: s.page && parseInt(s.page),
      lang: s.lang
    })),
    getState: (s: PublicSiteState) => s.search_overview,
    setState: (s: PublicSiteState, ss: CustomPagesState['search_overview']) => {
      const s1 = { ...s, search_overview: ss }

      return s1
    },
    updateStateBasesOnRoute: (s, r) => {
      if (r.kind != 'search_overview') return s
      const page = isNaN(+r.page) ? 0 : +r.page
      const query = r.query

      return {
        ...s,
        search_overview: {
          overview_page: page,
          current_query: query,
          get_searches: Search(query, "", page, 10, r.lang)
        }
      }
    }
}

const options: { style?: LinkGridBlockStyle } = {
  style: linkGridBlockClasses
}

const searchOverview = (
  page: PaginatedItem<SearchResultItem>,
  setPage: (page: number) => void,
  setQuery: (query: string) => void,
  runQuery: () => void,
  current_page: number,
  current_query: string,
  lang: string
) => {
  return (
    <section className="block block--search-results" key={'search-overview'}>
      <div className="block__inner grid--spacing">
        <div className="block__content container container--m grid--gutter">
          <h2>{t("search:search")}</h2>
          
          <form onSubmit={e => {
            e.preventDefault()
            location.href=`/${lang}/search/${current_query}/0`
          }}
          className='search-results__form'>
            <input 
              className='search-results__input'
              autoFocus
              type="search"
              value={current_query}
              onChange={e => setQuery(e.currentTarget.value)}
            />
          </form>
          {!page.items || page.items.count() == 0 ? (
            <p className='search-results__text'>{t('search:no_results')}</p>
          ) : (
            <ul className='search-results__list'>
              {page.items.map((item: SearchResultItem) => {
                return searchItem(item)
              })}
            </ul>
          )}
            {page.pager && <Pagination pager={page.pager} setPage={setPage} />}
        </div>
      </div>
    </section>
  )
}

export const searchItem = (search_item: SearchResultItem) => {
  return (
      <li className="search-results__item result">
        {/* TO DO: Properly fix languages for NA */}
        <Link to={window.location.pathname?.startsWith("/na/") ? search_item.url.replace("/en/", "/na/") : window.location.pathname?.startsWith("/uk/") ? search_item.url.replace("/en/", "/uk/") : search_item.url} className="result__link">
          {/* TO DO: add content type in "result__label" below */}
          <div className="result__message">
            <h3 className="result__title title--s">{search_item.title}</h3>
            <p className="result__intro" dangerouslySetInnerHTML={{__html: Object.keys(search_item.content).map(key => search_item.content[key]?.join(' (...) ')).join(' (...) ')}}></p>
          </div>
        </Link>
      </li>
  )
}
